const isoToTimeString = (value, defaultValue='') => {
  const date = new Date(value);
  if(isNaN(date.getTime())) {
    return defaultValue;
  }
  const hours = date.getHours().toString().padStart(2, '0');
  const mins = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${mins}`;
};

const isoToTimeStringS = (value, defaultValue='') => {
  const date = new Date(value);
  if(isNaN(date.getTime())) {
    return defaultValue;
  }
  const hours = date.getHours().toString().padStart(2, '0');
  const mins = date.getMinutes().toString().padStart(2, '0');
  const secs = date.getSeconds().toString().padStart(2, '0');
  return `${hours}:${mins}:${secs}`;
};

export {isoToTimeString, isoToTimeStringS};